// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"2a0c1efadb61113ad84f","293":"36280c5689913df70c20"}[chunkId] + ".js";
};